import { ApprovalTypeEnum, JudgementStatus, ModelTypeEnum } from "~/application/types";

export function getApprovalStatus(status: JudgementStatus): string {
  switch (status) {
    case JudgementStatus.APPROVED:
      return "Aprovado";
    case JudgementStatus.DISAPPROVED:
      return "Reprovado";
    default:
      return "Em aberto";
  }
}

export function getApprovalTypeLabel(approvalType?: ApprovalTypeEnum): string {
  switch (approvalType) {
    case ApprovalTypeEnum.COST_CENTER:
      return "Centro de custo";
    case ApprovalTypeEnum.PHASE:
      return "Fase";
    case ApprovalTypeEnum.PROJECT:
      return "Projeto";
    case ApprovalTypeEnum.GROUP:
      return "Grupo";
    default:
      return "Não definido";
  }
}

export function getModelTypeLabel(modelType?: ModelTypeEnum): string {
  switch (modelType) {
    case ModelTypeEnum.TRAVEL:
      return "Viagem";
    case ModelTypeEnum.ADVANCE:
      return "Adiantamento";
    case ModelTypeEnum.BROKEN_POLICY:
      return "Fora da política";
    case ModelTypeEnum.EXPENSE_REPORT:
      return "Relatório de despesas";
    default:
      return "Não definido";
  }
}